import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SERVICES } from '@/data/mock';
import { Zap } from 'lucide-react';

export default function ServicesPage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);
  return (
    <div>
      <section className="relative py-24 border-b border-white/5">
        <div className="absolute inset-0 viso-grid opacity-40" />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-xs font-mono uppercase tracking-widest text-cyan-300 mb-3">Our services</div>
          <h1 className="font-display text-4xl md:text-6xl font-bold max-w-4xl leading-[1.05]"><span className="text-gradient">Eight stages. One outcome — autonomous operations.</span></h1>
          <p className="text-slate-400 mt-5 max-w-2xl">From advisory to enterprise-wide transformation, our teams and partner network are with you at every step.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {SERVICES.map((s) => (
            <div id={`stage-${s.stage}`} key={s.stage} className="scroll-mt-24 rounded-xl border border-white/10 bg-white/[0.02] p-6 hover:border-cyan-400/30 hover:bg-white/[0.04] transition-all">
              <div className="flex items-center justify-between">
                <span className="text-xs font-mono text-slate-500">Stage {s.stage}</span>
                <Zap className="w-3.5 h-3.5 text-cyan-300" />
              </div>
              <div className="font-display font-semibold text-xl mt-2">{s.title}</div>
              <ul className="mt-4 space-y-2">
                {s.items.map((it) => (
                  <li key={it} className="text-sm text-slate-300 flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-cyan-300 mt-2" />{it}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
